import { z } from 'zod';
import { requiredString } from '../helpers';
export const Snapsheet_Get_Claim_1_ConfigValidator = z.object({
    connectionId: requiredString('Connection is required'),
    claimNumber: requiredString('Claim number is required'),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true;
        try {
            JSON.parse(val);
            return true;
        }
        catch {
            return false;
        }
    }, { message: 'Must be empty string or valid JSON' })
});
//# sourceMappingURL=snapsheet-get-claim-1.js.map